import jump from 'jump.js'
import throttle from 'lodash.throttle'
import debounce from 'lodash.debounce'
import ScrollSpy from './scrollspy'
import { TweenLite } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { getPosition, viewport } from '../helpers/helpers'

export default class Header {
  constructor(){
    this.siteNav = document.querySelector('.site-nav')
    this.anchors = Array.from(document.querySelectorAll('.site-nav a'))
    this.header = document.querySelector('.site-header')
    // this.wrapNav()


    if (this.siteNav) this.scrollspy = new ScrollSpy(this.siteNav);
    this.initValues()
    this.events()
  }

  initValues() {
    this.headerRect = this.header.getBoundingClientRect()
  }

  events() {
    this.anchors.forEach(el => el.addEventListener('click', this.smoothScroll.bind(this, el)))

    window.addEventListener('scroll', throttle(this.scrollEvent, 100).bind(this))

    // For reinitting values
    window.addEventListener('resize', debounce(this.initValues, 200).bind(this))
  }

  smoothScroll(el, e) {
    const targetString = el.hash;
    const target = document.querySelector(targetString);

    // jump(target, {
    //   offset: (this.headerRect.height * -1 + 10)
    // })

    if (target) {
      e.preventDefault();
      let y = getPosition(target).y - this.headerRect.height + 10;

      if (viewport().width <= 1024) {
        y = y - 33;
      }

      TweenLite.to(window, 1, { ease: Power3.easeInOut, scrollTo: { y: y, autoKill: false } });
    }
  }

  scrollEvent() {
    const scrolled = window.pageYOffset;

    if (scrolled > this.headerRect.height){
      this.header.classList.add('scrolled')
    } else {
      this.header.classList.remove('scrolled')
    }
  }
}
